import React from 'react';
import {Check} from "@sparkware/app-utils";
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {BrandSiteConfiguration} from '../../../../services/configurations/config-data-sections/header.configuration';
import {Link} from '../../../raw-components/link/link';
import {Icons} from '../../../icons/icons.component';
import {observer} from 'mobx-react';
import {CrossBrandListBox} from "./boxes/cross-brand-list.box";
import {CrossBrandItemBox} from "./boxes/cross-brand-item.box";
import {CrossBrandItemIconBox} from "./boxes/cross-brand-item-icon.box";

@observer
export class CrossBrandsComponent extends OrbitComponent<{}> {

  private _onBrandClick = (brandConfig: BrandSiteConfiguration) => {
    const isAuth = this.services.user.isAuthorized;
    const directLink = brandConfig.useDirectLink ? this.services.marketing.appendSCutToUrl(brandConfig.link) : undefined;

    this.services.externalLinks.openLink(
{
          source: brandConfig.externalLinkSource,
          sourceLink: directLink,
        },
        {dl: brandConfig.dl},
        brandConfig.useCallbackURL
    );

    this.services.analytics.sendAnalytics("Navigation", "Header", "Cross_" + (isAuth ? "Casino_" : "") + brandConfig.text)
  };

  private _getBrandIcon(brandClass: string) {

    if (!Check.isString(brandClass)) {
      return null;
    }
    let formattedBrandClass: "PokerBrandSmall" | "SportBrandSmall" | "CasinoBrandSmall" = (brandClass.charAt(0).toUpperCase() + brandClass.slice(1) + "BrandSmall") as "PokerBrandSmall" | "SportBrandSmall" | "CasinoBrandSmall";

    return Icons[formattedBrandClass];
  }

  private _renderCrossBrandLinks(sites: BrandSiteConfiguration[]) {

    return (
      <React.Fragment>
        {
          sites.map(brandConfig => {

            const BrandIcon = this._getBrandIcon(brandConfig.class);

            return (
              <Link key={brandConfig.class} className={`${brandConfig.class} cy-cross-brand-link`} href={brandConfig.link} box={CrossBrandItemBox} customProps={{[brandConfig.class]: true}} onClick={() => this._onBrandClick(brandConfig)}>
                <CrossBrandItemIconBox className={"cy-cross-brand-link-icon"}>
                  <BrandIcon/>
                </CrossBrandItemIconBox>
                {brandConfig.text}
              </Link>
            );
          })
        }
      </React.Fragment>
    );
  }

  render() {

    let crossBrandsConfig = this.services.configuration.data.header.cross_brand;

    if(!crossBrandsConfig) {
      return null;
    }

    if(!crossBrandsConfig.display) {
      return null;
    }

    return (
      <CrossBrandListBox className="cy-cross-brand-list">
        {this._renderCrossBrandLinks(crossBrandsConfig.sites)}
      </CrossBrandListBox>
    );
  }
}
